import React, { useState, useEffect } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function ChargeSlabFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const [schemes, setSchemes] = useState([]);
  const [comTypes, setComTypes] = useState([]);
  const {userid} = useSession();

  // Fetch dropdown data on mount
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        // ✅ Fetch scheme list
        const schemeForm = new FormData();
        schemeForm.append("action", "GET");
        schemeForm.append("userid", userid);
        const schemeRes = await fetch("https://pro.mokshiq.in/scheme_manager_action", {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: schemeForm,
        });
        const schemeData = await schemeRes.json();
        debugger;
        
          setSchemes(schemeData.data);
        

        // ✅ Fetch commission type list
        const comForm = new FormData();
        comForm.append("action", "GET");
        comForm.append("userid", userid);
        const comRes = await fetch("https://pro.mokshiq.in/commission_type_manager_action", {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: comForm,
        });
        const comData = await comRes.json();
        
          setComTypes(comData.data);
        
      } catch (err) {
        console.error("Error fetching dropdowns:", err);
      }
    };

    fetchDropdowns();
  }, []);

  

  const validateForm = () => {
    const requiredFields = ["fname", "name", "scheme", "com_type", "type"];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const value = document.getElementById(field)?.value.trim();
      if (!value) {
        newErrors[field] = `${field} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("fname", document.getElementById("fname").value.trim());
    formData.append("name", document.getElementById("name").value.trim());
    formData.append("scheme", document.getElementById("scheme").value);
    formData.append("com_type", document.getElementById("com_type").value);
    formData.append("admin", document.getElementById("admin").value);
    formData.append("white_label", document.getElementById("white_label").value);
    formData.append("super_dist", document.getElementById("super_dist").value);
    formData.append("distributer", document.getElementById("distributer").value);
    formData.append("retailer", document.getElementById("retailer").value);
    formData.append("type", document.getElementById("type").value);
    formData.append("id", userData?.id || "");
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid);

    try {
      const response = await fetch("https://pro.mokshiq.in/charge_slab_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
        if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Charge Slab" : "Add Charge Slab"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          {/* fname */}
          <div className="col-md-6">
            <label className="form-label">Start Slab</label>
            <input
              id="fname"
              className={`form-control ${errors.fname ? "is-invalid" : ""}`}
              defaultValue={userData?.fname || ""}
            />
            {errors.fname && <div className="text-danger">{errors.fname}</div>}
          </div>

          {/* name */}
          <div className="col-md-6">
            <label className="form-label">End Slab</label>
            <input
              id="name"
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              defaultValue={userData?.name || ""}
            />
            {errors.name && <div className="text-danger">{errors.name}</div>}
          </div>

          {/* scheme (dropdown from API) */}
          <div className="col-md-6">
            <label className="form-label">Scheme</label>
            <select id="scheme" className={`form-select ${errors.scheme ? "is-invalid" : ""}`} defaultValue={userData?.scheme || ""}>
              <option value="">-- Select Scheme --</option>
              {schemes.map((s) => (
                <option key={s.id} value={s.id}>{s.Name}</option>
              ))}
            </select>
            {errors.scheme && <div className="text-danger">{errors.scheme}</div>}
          </div>

          {/* com_type (dropdown from API) */}
          <div className="col-md-6">
            <label className="form-label">Commission Type</label>
            <select id="com_type" className={`form-select ${errors.com_type ? "is-invalid" : ""}`} defaultValue={userData?.com_type || ""}>
              <option value="">-- Select Commission Type --</option>
              {comTypes.map((c) => (
                <option key={c.id} value={c.id}>{c.Name}</option>
              ))}
            </select>
            {errors.com_type && <div className="text-danger">{errors.com_type}</div>}
          </div>

          {/* admin */}
          <div className="col-md-6">
            <label className="form-label">Admin</label>
            <input id="admin" className="form-control" defaultValue={userData?.admin || ""} />
          </div>

          {/* white_label */}
          <div className="col-md-6">
            <label className="form-label">White Label</label>
            <input id="white_label" className="form-control" defaultValue={userData?.white_label || ""} />
          </div>

          {/* super_dist */}
          <div className="col-md-6">
            <label className="form-label">Super Distributor</label>
            <input id="super_dist" className="form-control" defaultValue={userData?.super_dist || ""} />
          </div>

          {/* distributer */}
          <div className="col-md-6">
            <label className="form-label">Distributor</label>
            <input id="distributer" className="form-control" defaultValue={userData?.distributer || ""} />
          </div>

          {/* retailer */}
          <div className="col-md-6">
            <label className="form-label">Retailer</label>
            <input id="retailer" className="form-control" defaultValue={userData?.retailer || ""} />
          </div>

          {/* type (dropdown) */}
          <div className="col-md-6">
            <label className="form-label">Type</label>
            <select id="type" className={`form-select ${errors.type ? "is-invalid" : ""}`} defaultValue={userData?.type || ""}>
              <option value="">-- Select Type --</option>
              <option value="fixed">Fixed</option>
              <option value="percent">Percentage</option>
            </select>
            {errors.type && <div className="text-danger">{errors.type}</div>}
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
